export class ApplicationNonBorrowerEntityApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEntities({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/non-borrower-entity`);
  }

  async createEntity({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.post(`/application/${applicationId}/non-borrower-entity`, body, {
      params: { withLoanOptionId },
    });
  }

  async editEntity({ nonBorrowerEntityId, applicationId, withLoanOptionId, ...body }) {
    return this.#http.put(
      `/application/${applicationId}/non-borrower-entity/${nonBorrowerEntityId}`,
      body,
      { params: { withLoanOptionId } },
    );
  }

  async editEntities({ applicationId, withLoanOptionId, body }) {
    return this.#http.put(`/application/${applicationId}/non-borrower-entity`, body, {
      params: { withLoanOptionId },
    });
  }

  async deleteEntity({ nonBorrowerEntityId, applicationId, tabId, withLoanOptionId }) {
    return this.#http.delete(
      `/application/${applicationId}/non-borrower-entity/${nonBorrowerEntityId}`,
      { params: { withLoanOptionId, tabId } },
    );
  }
}
